export const colors = {
    'C2': '#428533',
    'C4': '#061b6f'
}